import React from "react"
import { storyblokEditable } from "@storyblok/react"

import Markdown from "react-markdown"
import { useStaticQuery, graphql } from "gatsby"
import { getImage } from "gatsby-plugin-image"

import { CareerFacesTeaser, transformLinkUri } from "gatsby-theme-gba"

const CareerFacesTeaserEditable = ({ blok }) => {
  const { file, allFile } = useStaticQuery(graphql`
    query CareerFacesTeaserExampleQuery {
      file(relativePath: { eq: "career-faces-teaser.jpg" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      allFile(filter: { id: { regex: "/(?:.*)careerFacesTeaser/" } }) {
        edges {
          node {
            id
            name
            childImageSharp {
              gatsbyImageData(width: 1360, quality: 80)
            }
          }
        }
      }
    }
  `)

  const filteredFiles = allFile.edges.filter(
    (projectFile) =>
      blok.image && projectFile.node.id.includes(blok.image.substring(1))
  )

  const imageFile = filteredFiles[0]
    ? getImage(filteredFiles[0].node)
    : blok.image

  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  }

  const replaceAll = (str, term, replacement) =>
    str.replace(new RegExp(escapeRegExp(term), "g"), replacement)

  return (
    <div {...storyblokEditable(blok)} key={blok._uid}>
      <CareerFacesTeaser
        position={blok.position || "Position"}
        location={blok.location || "Location"}
        name={blok.name || "Name"}
        quote={blok.quote || "Quote"}
        linkText={blok.linkText}
        linkTextExpanded={blok.linkTextExpanded}
        image={imageFile || getImage(file)}
        imageAlt={blok.imageAlt}
        currentLanguage={blok.currentLanguage}
      >
        <Markdown
          transformLinkUri={(uri) => {
            return transformLinkUri(uri, "", blok.currentLanguage)
          }}
        >
          {replaceAll(blok.body, "\u2028", "")}
        </Markdown>
      </CareerFacesTeaser>
    </div>
  )
}

export default CareerFacesTeaserEditable
